// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingQuestionConfigCard_root__5jQLi","icons":"UnderwritingQuestionConfigCard_icons__OgFkE","title":"UnderwritingQuestionConfigCard_title__63z+Y"};